import React from 'react';
import EventbuizzFooter from '../../../EventbuizzFooter';

const AuthLayout = ({ children, ...rest }) => {
    return (
        <div id="App" className="signup-wrapper">
            <main role="main" className="main-section">
                <div className="container">
                    <div className="wrapper-box">
                        {children}
                    </div>
                </div>
            </main>
            <EventbuizzFooter />
        </div>
    )
}

const AuthLayoutRoute = ({ children, ...rest }) => {
    return (
        <AuthLayout>
            {children}
        </AuthLayout>
    )
};

export default AuthLayoutRoute;